<template>
  <div class="main-feed mt-5">
    <div>
      <v-row class="ma-0">
        <h2>Litter Registrations</h2>
        <v-spacer></v-spacer>
        <RequestStatusesSelectMenu
          :menu.sync="menu"
          v-on:apply="applyFilters"
          v-on:updateStatuses="statuses = $event"
        />
      </v-row>
    </div>
    <v-data-table 
      :loading="loading"
      :headers="headers"
      :options.sync="options"
      :items="paginatedResponse.data"
      :server-items-length="paginatedResponse.totalCount"
      :search="search"
      :footer-props="footerProps">
      <template v-slot:item.requestId="{ item }">
        <router-link :to="`/admin/registration/litters/${item.requestId}`" target="_blank">{{
          item.requestId
        }}</router-link>
      </template>
      <template v-slot:item.litterId="{ item }">
        <router-link :to="`/admin/litters/${item.litterId}`" target="_blank">{{
          item.litterId
        }}</router-link>
      </template>
      <template v-slot:item.submittedAt="{ item }">
        <localized-date-time :instant="item.submittedAt" />
      </template>
      <template v-slot:item.requester="{ item }">
        <span>{{ item.requester.lastName }}, {{ item.requester.firstName }}</span>
      </template>
      <template v-slot:item.whelpingDate="{ item }">
        <localized-date :date="item.whelpingDate" />
      </template>
      <template v-slot:item.awaitingDocuments="{ item }">
        <ul v-for="doc in item.awaitingDocuments">
          <li>
            <span>{{doc.parentType}}: {{doc.id}}</span>
          </li>
        </ul>
      </template>
    </v-data-table>
</div>
</template>

<script lang="ts">
import Vue from "vue";
import RequestStatusesSelectMenu from "@/components/common/inputs/RequestStatusesSelectMenu.vue";

import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import workflowService from '@/services/admin/workflowService';

export default Vue.extend({
  name: "LitterRequestList",
  components: { RequestStatusesSelectMenu },
  props: {
    readyToApproveOnly: String,
  },
  data: function () {
    return {
      loading: false,
      paginatedResponse: {} as PaginatedResponse<object>,
      menu: false,
      search: '',
      statuses: ["RequestFinalized"],
      options: {} as PaginationOptions,
      headers: [
        { text: "#ID", align: "left", value: "requestId" },
        { text: "Litter Id", align: "left", value: "litterId" },
        { text: "Submitted at", align: "left", value: "submittedAt" },
        { text: "Requester", align: "left", value: "requester", sortable: false },
        { text: "Status", align: "left", value: "status" },
        { text: "Dam", align: "left", value: "damId" },
        { text: "Whelping Date", align: "left", value: "whelpingDate" },
        { text: "Awaiting documents", align: "left", value: "awaitingDocuments", sortable: false },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
    };
  },
  created: function () { this.loadList() },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    }
  },
  methods: {
    applyFilters: function () {
      this.menu = false;
      this.loadList();
    },
    loadList: async function () {
      this.loading = true;
      const {
        page,
        itemsPerPage,
      } = this.options;

      const response = await workflowService.getLitterRegistrationsList({
        ...this.options,
        page: (page ?? 1) - 1,
        itemsPerPage: itemsPerPage ?? 10
      }, this.$data.statuses);

      this.loading = false;
      this.paginatedResponse = response;
    }
  },
});
</script>
